export default __webpack_public_path__ + "static/media/myjourney-bluetree-empty.ff68071d.svg";